'use strict'

export const TYPOGRAPHY = {
  base: 16,
  ratio: 1.25,
  subSequence: true,
  templates: {}
}
